import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../images/logo-full.png";
import ForgotPasswordModal from "../components/Auth/ForgotPasswordModal";
import ResetPasswordModal from "../components/Auth/ResetPasswordModal";

const ForgotPassword = () => {
  const [showForgotModal, setShowForgotModal] = useState(true);
  const [showResetModal, setShowResetModal] = useState(false);

  return (
    <>
      <div className="authincation h-100 p-meddle">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-md-6">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="auth-form">
                      <div className="text-center mb-3">
                        <Link to="/login">
                          <img src={logo} alt="Fund8 Logo" />
                        </Link>
                      </div>
                      <h4 className="text-center mb-4">Password Recovery</h4>

                      <div className="text-center">
                        <button
                          className="btn btn-primary btn-block mb-3"
                          onClick={() => setShowForgotModal(true)}
                        >
                          Request Reset Token
                        </button>

                        <button
                          className="btn btn-outline-primary btn-block mb-3"
                          onClick={() => setShowResetModal(true)}
                        >
                          I Have a Token
                        </button>
                      </div>

                      <div className="new-account mt-3 text-center">
                        <p>
                          <Link to="/login" className="text-primary">
                            ← Back to Login
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ForgotPasswordModal
        show={showForgotModal}
        onHide={() => setShowForgotModal(false)}
      />

      <ResetPasswordModal
        show={showResetModal}
        onHide={() => setShowResetModal(false)}
      />
    </>
  );
};

export default ForgotPassword;
